export const POSTHOG_EVENTS = {
    CHECKIN_CREATED: 'checkin-created',
    BUTTON_CLICKED: 'button_clicked',
    FILE_DOWNLOADED: 'file_downloaded',
    REPORT_DOWNLOADED: 'report_downloaded',
    VIDEO_ACTIONED: 'video_actioned',
    LOGIN: 'login',
    SURVEYS_VIEW_ASSIGNED_SURVEYS_LEFT_MENU: 'surveys_view_assigned_surveys_left_menu',
    SURVEYS_VIEW_SURVEY_REPORT_LEFT_MENU: 'surveys_view_survey_report_left_menu',
    SURVEYS_VIEW_MY_SURVEYS_LEFT_MENU: 'surveys_view_my_surveys_left_menu',
    SURVEYS_VIEW_SURVEY_SUPPORT_LEFT_MENU: 'surveys_view_survey_support_left_menu',
    SURVEYS_PREVIEW_AND_ASSIGN_BUTTON_CLICKED: 'surveys_preview_and_assign_button_clicked',
    SURVEYS_VIEW_AND_EDIT_BUTTON_CLICKED: 'surveys_view_and_edit_button_clicked',
    SURVEYS_ASSIGN_SURVEY_BUTTON_CLICKED: 'surveys_assign_survey_button_clicked',
    SURVEYS_VIEW_QUESTION_ANALYSIS_BUTTON_CLICKED: 'surveys_view_question_analysis_button_clicked',
    SURVEYS_DOWNLOAD_PDF_REPORT_BUTTON_CLICKED: 'surveys_download_pdf_report_button_clicked',
    SURVEYS_DOWNLOAD_EXCEL_REPORT_BUTTON_CLICKED: 'surveys_download_excel_report_button_clicked',
    SURVEYS_COMPARE_SURVEYS_BUTTON_CLICKED: 'surveys_compare_surveys_button_clicked',
    SURVEYS_QUESTION_ANALYSIS_GRAPH_INTERACTION: 'surveys_question_analysis_graph_interaction',
    SURVEYS_POLAR_CHART_INTERACTION: 'surveys_polar_chart_interaction',
    SURVEYS_VIEW_SURVEY_PROGRESS_BUTTON_CLICKED: 'surveys_view_survey_progress_button_clicked',
};
